export class Project {
  companyId: string;

  companyName: string;

  projectName: string;

  userName: string;

  email: string;

  phone: string;

  comments: string;

  licensedBeds: number;

  selectionType: string;

  bedRate: number;

  bedRateOther: number;

  vacancyFactor: number; // TODO: Should this be a float of some sort

  inflationRate: number; // TODO: float?

  foodCost: number;

  foodCostOperatingExpenses: string; // TODO: Why a string?

  startUpMonth: number;

  caregiverDayRatio: string;

  caregiversPerDay: number;

  caregiverNightRatio: string;

  caregiversPerNight: number;

  averageNightShiftHours: number;

  averageHourlyWage: number;

  operatingCapital: number; // TODO: What is this?

  maintenanceReserve: number;

  maintenanceReserveContribution: number;

  projectNotes: string;

  videoUrl: string;

  audioUrl: string;

  fileUrl: string;

  totalFunds: number;

  totalProjectFunding: number;

  returnOnInvestment: number;

  minimumInvestment: number;

  ownerContribution: number;

  term: number;

  totalCurrentRevenue: number;

  totalProjectedRevenue: number;

  totalFutureRevenue: number;

  payrollValuesArray: number[];

  generalValuesArray: number[];

  opexValuesArray: number[];

  // Investment Essentials
  lienPosition: string;

  personalGuarantee: string;

  profitSharePreferred: number;

  profitShareExit: number;

  isDeleted: boolean;

  reportData: string[];
}



// WEBPACK FOOTER //
// ./src/app/models/project.ts